// src/hooks/useScreens.js
import { useEffect, useState } from "react";
import { getScreens } from "@/services/screens.service";
import { localizeField } from "@/utils/i18nBackend";

function normalizeScreenImage(image) {
  if (!image || typeof image !== "string") return null;

  // fix backend typo: /publicassets/ => /public/assets/
  const fixedImage = image.replace("/publicassets/", "/public/assets/");

  if (fixedImage.startsWith("http")) {
    return fixedImage;
  }

  if (fixedImage.startsWith("public/")) {
    return `https://www.programshouse.com/hr/${fixedImage}`;
  }

  if (fixedImage.startsWith("assets/")) {
    return `https://www.programshouse.com/hr/public/${fixedImage}`;
  }

  return `https://www.programshouse.com/hr/public/${fixedImage}`;
}

export function useScreens(type, isAR = false) {
  const [screens, setScreens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    async function fetchScreens() {
      try {
        setLoading(true);
        setError(null);

        const result = await getScreens();

        const formattedScreens = Array.isArray(result?.data)
          ? result.data
              .filter((item) => item.type === type)
              .map((item) => {
                const image = isAR
                  ? item.image_ar || item.image_en
                  : item.image_en || item.image_ar;

                return {
                  id: item.id,
                  title: localizeField(item, "title"),
                  image: normalizeScreenImage(image),
                  type: item.type,
                };
              })
              .filter((item) => item.title && item.image)
          : [];

        if (active) {
          setScreens(formattedScreens);
        }
      } catch (err) {
        if (active) {
          setError(
            err?.response?.data?.message ||
              err?.message ||
              "Failed to load screens"
          );
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    fetchScreens();

    return () => {
      active = false;
    };
  }, [type, isAR]);

  return {
    screens,
    loading,
    error,
  };
}